import { PiGithubLogo, PiXLogo, PiEnvelope, PiChat, PiCloud, PiLink, PiGlobe } from 'react-icons/pi'
import { FaMastodon, FaEthereum, FaFacebook, FaInstagram } from 'react-icons/fa'
import { SiThreads, SiPixelfed } from 'react-icons/si'

export const getIcon = (iconName: string) => {
    switch (iconName.toLowerCase()) {
        case 'github':
            return <PiGithubLogo className="w-5 h-5" />
        case 'mastodon':
        case 'masto':
            return <FaMastodon className="w-5 h-5 text-[#6364FF]" />
        case 'threads':
            return <SiThreads className="w-5 h-5" />
        case 'bluesky':
            return <PiCloud className="w-5 h-5 text-blue-500" />
        case 'pixelfed':
            return <SiPixelfed className="w-5 h-5" />
        case 'ethereum':
        case 'ens':
            return <FaEthereum className="w-5 h-5 text-[#3C3C3D]" />
        case 'signal':
            return <PiChat className="w-5 h-5 text-blue-500" />
        case 'x':
        case 'twitter':
            return <PiXLogo className="w-5 h-5" />
        case 'email':
            return <PiEnvelope className="w-5 h-5" />
        case 'website':
            return <PiGlobe className="w-5 h-5 text-blue-500" />
        case 'facebook':
            return <FaFacebook className="w-5 h-5 text-[#1877F2]" />
        case 'instagram':
            return <FaInstagram className="w-5 h-5 text-[#E4405F]" />
        default:
            return <PiLink className="w-5 h-5" />
    }
}

export const PLATFORMS = [
    { id: 'github', name: 'GitHub' },
    { id: 'x', name: 'X (Twitter)' },
    { id: 'mastodon', name: 'Mastodon' },
    { id: 'bluesky', name: 'Bluesky' },
    { id: 'signal', name: 'Signal' },
    { id: 'threads', name: 'Threads' },
    { id: 'pixelfed', name: 'Pixelfed' },
    { id: 'ethereum', name: 'Ethereum/ENS' },
    { id: 'email', name: 'Email' },
    { id: 'website', name: 'Website' },
    { id: 'facebook', name: 'Facebook' },
    { id: 'instagram', name: 'Instagram' },
]
